import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { getReports } from '../../api/report';
import { generateReport } from '../../api/reportSchedule';
import { ReportSlice } from './types';

const initialState: Array<ReportSlice> = [];

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    loadReports: (state, action: PayloadAction<ReportSlice[]>) => {
      return action.payload;
    }
  }
});

export const { loadReports } = reportsSlice.actions;

export const fetchReports = (station_id: number): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  try {
    const reports = await getReports(user.api_key, station_id)

    dispatch(loadReports(reports.reverse()));
  } catch (err) {
    console.error(err.toString())
  }
}

export const createReport = (station_id: number, report_schedule_id: number, date: string): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  console.log('create report');
  try {
    
    const generate = await generateReport(user.api_key, report_schedule_id, date)

  } catch (err) {
    console.error(err.toString())
  } finally {
    dispatch(fetchReports(station_id));
  }
  
}

export const selectAllReports = (state: RootState) => {
  return state.reports;
}

export default reportsSlice.reducer;
